module.exports = __webpack_public_path__ + "static/images/bca.r4yaXiP.svg";